import { TakerMarket } from '@/enterprise/data/useTakerMarkets';

/**
 * Slices one page out of the full list. `page` is 1-based; anything below 1 is treated as the
 * first page so a hand-edited URL can't produce an empty table.
 */
export const paginate = <T>(items: T[], { page, pageSize }: { page: number; pageSize: number }) => {
  const safePage = Math.max(1, page);
  const start = (safePage - 1) * pageSize;

  return {
    rows: items.slice(start, start + pageSize),
    hasNextPage: start + pageSize < items.length,
  };
};

/**
 * Whether a buyer has at least one division fully set up for Instant Pay. SEA computes
 * `isInstantPayAllowed` (enabled, onboarding complete, custodial funding confirmed, USD); the
 * Substitutions tab is hidden for buyers without one.
 */
export const hasInstantPayAllowedDivision = (takerMarkets: TakerMarket[]) =>
  takerMarkets.some((takerMarket) => takerMarket.isInstantPayAllowed);
